var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { postcodeValidator } from "postcode-validator";
import { getCountries } from "country-state-picker";
import { regexEmailValidation } from "../../shared/regex";
export var MobileNumberPattern = new RegExp("^[0-9]+$");
export var StringPattern = new RegExp("");
export var zipNumberPattern = new RegExp("^[0-9]+$");
export var checkEmailValidation = function (inputEmailId) {
    if (inputEmailId.match(regexEmailValidation)) {
        return false;
    }
    else {
        return true;
    }
};
export var checkMobileValidation = function (inputNumber) {
    var isValidPattern = MobileNumberPattern.test(inputNumber);
    var isValidLength = (inputNumber === null || inputNumber === void 0 ? void 0 : inputNumber.length) >= 10;
    return !isValidPattern || !isValidLength;
};
export var checkStringValidation = function (inputString) {
    if (inputString.match(StringPattern)) {
        return false;
    }
    else {
        return true;
    }
};
export var checkZipNumberValidation = function (inputNumber, countryCode) {
    var countries = getCountries();
    var countryCodes = countries === null || countries === void 0 ? void 0 : countries.map(function (country) { return country === null || country === void 0 ? void 0 : country.code; });
    var validCountryCodes = __spreadArray([], countryCodes, true);
    if ((validCountryCodes === null || validCountryCodes === void 0 ? void 0 : validCountryCodes.includes(countryCode)) && postcodeValidator(inputNumber, countryCode === null || countryCode === void 0 ? void 0 : countryCode.toUpperCase())) {
        return false;
    }
    else {
        return true;
    }
};
